"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("../styles/_used-storage.scss");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var PERCENT_COLOUR_MAP = function PERCENT_COLOUR_MAP(percent) {
  if (percent > 75) {
    return '#ED1C24';
  }

  if (percent > 0) {
    return '#27BAA1';
  }

  return 'none';
};

function UsedStorage(_ref) {
  var total = _ref.totalStorageAllowance,
      current = _ref.currentStorageUsage,
      usedPercent = _ref.usedPercent;
  return _react.default.createElement("div", {
    className: "used-storage"
  }, _react.default.createElement("div", {
    className: "used-storage__text"
  }, _react.default.createElement("strong", null, "".concat(current || '0.00', " GB")), _react.default.createElement("span", null, " of ".concat(total, " GB Used"))), _react.default.createElement("div", {
    className: "used-storage__bar__container"
  }, _react.default.createElement("span", {
    className: "used-storage__bar__percent",
    style: {
      width: "".concat(usedPercent, "%"),
      background: PERCENT_COLOUR_MAP(usedPercent)
    }
  })));
}

var _default = (0, _react.memo)(UsedStorage);

exports.default = _default;